<template>
  <span class="base-chip">
    {{ label }}
  </span>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true
  }
});
</script>

<style scoped>
.base-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  line-height: .8rem;
  background-color: #e5e7eb;
  color: #374151;
  font-weight: 400;
  margin: 0;
}
</style>
